/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_No_CameraInputs */

const vi_fleet_no_camera = /** @type {(inputs: Fleet_No_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có camera`)
};

/**

* @param {Fleet_No_CameraInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_no_camera = /** @type {((inputs?: Fleet_No_CameraInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_No_CameraInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_no_camera(inputs)
});